import { findTagByJsonQuery } from './findTagByJsonQuery';
import { ITag } from '../../types/tags';

/**
 * Добавляет новый тег в массив тегов
 * @param {ITag[]} tags - исходный массив тегов
 * @param {ITag} tag - тег для добавления в массив тегов
 * @returns {ITag[]} новый массив тегов
 */
export const appendTag = (tags: ITag[], tag: ITag): ITag[] => {
  return findTagByJsonQuery(tags, tag.jsonQuery) ? tags : [...tags, tag];
};
